import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import TariffDTO from '../../../../dto/TarifDTO';

export default function TariffForm(props) {
  const { control, formMeta } = props;
  const dto = new TariffDTO();
  const attributes = dto.getAttributesByName();

  return (
    <Row className="row-cols-2 mb-2">
      <FieldDTOWithCol
        control={control}
        formMeta={formMeta}
        type="file"
        component={FileInput}
        dtoObject={attributes.tariff_file}
        variant="material"
      />
    </Row>
  );
}
